/** @type {Styles} */

export const styles = {
  emptyRootContent: {
    width: '100%',
    flex: 0,
  },
  breadcrumbsWrapper: {
    width: '100%',
    minHeight: { xs: 48, sm: 64 },

    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: (theme) => theme.spacing(4),
  },
  breadcrumbs: ({ breakpoints }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingX: { xs: 2, sm: 3 },
    flex: 1,
    width: '100%',
    minHeight: { xs: 48, sm: 64 },

    [breakpoints.down('sm')]: {
      minHeight: 48,
    },
  }),
}

export const handleStylesWithProps = (count) => ({
  icon: {
    color: count ? 'primary.main' : 'gray.64',
    fontSize: '1.5rem',
    marginLeft: count ? 1 : 0,
  },
  buttonBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    bgcolor: count && 'info.lightest',
    borderRadius: 2,
    maxWidth: 74,
    height: 40,
    border: 'gray.80',
    ...(!count && {
      width: 40,
    }),
    marginLeft: 'auto',
    px: 1,
    marginBottom: 1.25,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  exportWidgets: {
    textAlign: 'center',
  },
})
